import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="section bg-paper">
      <div className="container-x text-center max-w-md mx-auto" data-testid="not-found">
        <div className="text-overline mb-3">404</div>
        <h1 className="font-heading text-5xl">Page Not Found</h1>
        <p className="mt-4 opacity-80">The page you were looking for does not exist.</p>
        <Link to="/" className="mt-6 inline-flex px-5 py-2.5 rounded-full btn-brand text-sm">Return Home</Link>
      </div>
    </section>
  );
}
